import {createStore} from 'vuex';
import persistedstate from 'vuex-persistedstate';

import masterdata_cafe from '@/js/data/cafe/masterdata';
import allergys_cafe from '@/js/data/cafe/allergys';
import kioskitem_cafe from '@/js/data/cafe/kioskitem';
import receiptdiscount_cafe from '@/js/data/cafe/receiptdiscount';
import recommenditem_cafe from '@/js/data/cafe/recommenditem';
import tbmstopt_cafe from '@/js/data/cafe/tbmstopt';
import tbmstitem_cafe from '@/js/data/cafe/tbmstitem';

import masterdata_food from '@/js/data/food/masterdata';
import allergys_food from '@/js/data/food/allergys';
import kioskitem_food from '@/js/data/food/kioskitem';
import receiptdiscount_food from '@/js/data/food/receiptdiscount';
import recommenditem_food from '@/js/data/food/recommenditem';
import tbmstopt_food from '@/js/data/food/tbmstopt';
import tbmstitem_food from '@/js/data/food/tbmstitem';

import kioskitem_sco from '@/js/data/sco/kioskitem';

const store = createStore({
  state() {
    return {
      adminId: '',
      adminPw: '',
      product: null,
      adminModeYn: false,
      posConfig: null,
      masterData: null,
      darkModeYn: false,
      helperHeightYn: false,
      kioskItem: null,
      timer: null,
      orderType: 1,
      baskets: null,
      allergys: null,
      recommendItem: null,
      orgBaskets: null,
      resetYn: true,
      firstBootYn: true,
      settingYn: false,
      resetHomeYn: false,
      returnToIdleDelay: 30,
      inspectYn: false,
      isSimpleToken: false,
      currencyUnit: '001',
      currUnitText: '원',
      posmasterRenewalYn: false,
      shopId: '',
      posNo: '',
      cpCd: '',
      storeCd: '',
      firstPosTranYn: true,
      receiptDiscount: null,
      membershipApplyYn: false,
      openYn: 'N',
      manualYn: 'N',
      manualOpenDate: null,
      tbMstOpt: [],
      tbMstItem: [],
      settingType: 1,
      locale: '',
    };
  },
  plugins: [
    persistedstate({
      storage: window.sessionStorage,
      paths: [
        'settingYn',
        'firstBootYn',
        'posConfig',
        'masterData',
        'kioskItem',
        'baskets',
        'allergys',
        'recommendItem',
        'orgBaskets',
        'returnToIdleDelay',
        'isSimpleToken',
        'currencyUnit',
        'currUnitText',
        'posmasterRenewalYn',
        'firstPosTranYn',
        'receiptDiscount',
        'membershipApplyYn',
        'openYn',
        'manualYn',
        'manualOpenDate',
        'tbMstOpt',
        'tbMstItem',
        'settingType',
        'locale',
      ],
    }),
  ],
  getters: {
    getSettingType(state) {
      return state.settingType;
    },
    getProduct(state) {
      return state.product;
    },
    getPosConfig(state) {
      return state.posConfig;
    },
    getAdminId(state) {
      return state.adminId;
    },
    getMasterData(state) {
      return state.masterData;
    },
    getDarkModeYn(state) {
      return state.darkModeYn;
    },
    getHelperHeightYn(state) {
      return state.helperHeightYn;
    },
    getTbMstOpt(state) {
      return state.tbMstOpt;
    },
    getTbMstItem(state) {
      return state.tbMstItem;
    },
    getKioskItem(state) {
      return state.kioskItem;
    },
    getOrderType(state) {
      return state.orderType;
    },
    getBaskets(state) {
      return state.baskets;
    },
    getAllergys(state) {
      return state.allergys;
    },
    getRecommendItem(state) {
      return state.recommendItem;
    },
    getOrgBaskets(state) {
      return state.orgBaskets;
    },
    getFirstBootYn(state) {
      return state.firstBootYn;
    },
    getSettingYn(state) {
      return state.settingYn;
    },
    getAdminModeYn(state) {
      return state.adminModeYn;
    },
    getResetHomeYn(state) {
      return state.resetHomeYn;
    },
    getInspectYn(state) {
      return state.inspectYn;
    },
    getIsSimpleToken(state) {
      return state.isSimpleToken;
    },
    getCurrencyUnit(state) {
      return state.currencyUnit;
    },
    getCurrUnitText(state) {
      return state.currUnitText;
    },
    getPosmasterRenewalYn(state) {
      return state.posmasterRenewalYn;
    },
    getShopId(state) {
      return state.shopId;
    },
    getPosNo(state) {
      return state.posNo;
    },
    getCpCd(state) {
      return state.cpCd;
    },
    getStoreCd(state) {
      return state.storeCd;
    },
    getFirstPosTranYn(state) {
      return state.firstPosTranYn;
    },
    getReceiptDiscount(state) {
      return state.receiptDiscount;
    },
    getMembershipApplyYn(state) {
      return state.membershipApplyYn;
    },
    getOpenYn(state) {
      return state.openYn;
    },
    getManualYn(state) {
      return state.manualYn;
    },
    getManualOpenDate(state) {
      return state.manualOpenDate;
    },
    getLocale(state) {
      return state.locale;
    },
  },
  mutations: {
    setSettingType(state, settingType) {
      state.settingType = settingType;
    },
    setProduct(state, prd) {
      state.product = prd;
    },
    setPosConfig(state, config) {
      if (config != null) state.returnToIdleDelay = config.posConfig.returnToIdleDelay;
      state.posConfig = config;
    },
    setAdminId(state, adminId) {
      state.adminId = adminId;
    },
    setAdminPw(state, adminPw) {
      state.adminPw = adminPw;
    },
    setMasterData(state, materData) {
      state.masterData = materData;
    },
    setDarkModeYn(state) {
      state.darkModeYn = state.darkModeYn ? false : true;
    },
    setHelperHeightYn(state) {
      state.helperHeightYn = state.helperHeightYn ? false : true;
    },
    setReset(state) {
      state.darkModeYn = false;
      state.helperHeightYn = false;
    },
    setTbMstOpt(state, tbMstOpt) {
      state.tbMstOpt = tbMstOpt;
    },
    setTbMstItem(state, tbMstItem) {
      state.tbMstItem = tbMstItem;
    },
    setKioskItem(state, kioskItem) {
      state.kioskItem = kioskItem;
    },
    setOrderType(state, orderType) {
      state.orderType = orderType;
    },
    setBaskets(state, baskets) {
      state.baskets = baskets;
    },
    setAllergys(state, allergys) {
      state.allergys = allergys;
    },
    setRecommendItem(state, recommendItem) {
      state.recommendItem = recommendItem;
    },
    setOrgBaskets(state, orgBaskets) {
      state.orgBaskets = orgBaskets;
    },
    setFirstBootYn(state, firstBootYn) {
      state.firstBootYn = firstBootYn;
    },
    setSettingYn(state, settingYn) {
      state.settingYn = settingYn;
    },
    setAdminModeYn(state, adminModeYn) {
      state.adminModeYn = adminModeYn;
    },
    setResetHomeYn(state, resetHomeYn) {
      state.resetHomeYn = resetHomeYn;
    },
    setInspectYn(state, inspectYn) {
      state.inspectYn = inspectYn;
    },
    setIsSimpleToken(state, isSimpleToken) {
      state.isSimpleToken = isSimpleToken;
    },
    setCurrencyUnit(state, currencyUnit) {
      state.currencyUnit = currencyUnit;
    },
    setCurrUnitText(state, currUnitText) {
      state.currUnitText = currUnitText;
    },
    setOpenYn(state, openYn) {
      state.openYn = openYn;
    },
    setManualYn(state, manualYn) {
      state.manualYn = manualYn;
    },
    setManualOpenDate(state, manualOpenDate) {
      state.manualOpenDate = manualOpenDate;
    },
    setLoginCashierId(state, loginCashierId) {
      state.posConfig.loginCashierId = loginCashierId;
    },
    setPosmasterRenewalYn(state, posmasterRenewalYn) {
      state.posmasterRenewalYn = posmasterRenewalYn;
    },
    setShopId(state, shopId) {
      state.shopId = shopId;
    },
    setPosNo(state, posNo) {
      state.posNo = posNo;
    },
    setCpCd(state, cpCd) {
      state.cpCd = cpCd;
    },
    setStoreCd(state, storeCd) {
      state.storeCd = storeCd;
    },
    setFirstPosTranYn(state, firstPosTranYn) {
      state.firstPosTranYn = firstPosTranYn;
    },
    setReceiptDiscount(state, receiptDiscount) {
      state.receiptDiscount = receiptDiscount;
    },
    setMembershipApplyYn(state, membershipApplyYn) {
      state.membershipApplyYn = membershipApplyYn;
    },
    setDefaultLanguage(state, defaultLanguage) {
      state.posConfig.posConfig.defaultLanguage = defaultLanguage;
    },
    setLocale(state, locale) {
      state.locale = locale;
    },
  },
  actions: {
    setSettingType(context, settingType) {
      context.commit('setSettingType', settingType);
    },
    setAdminModeYn(context, adminModeYn) {
      context.commit('setAdminModeYn', adminModeYn);
    },
    setFirstBootYn(context, firstBootYn) {
      context.commit('setFirstBootYn', firstBootYn);
    },
    setSettingYn(context, settingYn) {
      context.commit('setSettingYn', settingYn);
    },
    setReset(context) {
      context.commit('setReset');
    },
    setOrderType(context, orderType) {
      context.commit('setOrderType', orderType);
    },
    setBaskets(context, baskets) {
      context.commit('setBaskets', baskets);
    },
    setOrgBaskets(context, orgBaskets) {
      context.commit('setOrgBaskets', orgBaskets);
    },
    resetIdle(context) {
      var currentUrl = window.location.pathname;
      if (context.state.returnToIdleDelay > 0) {
        clearTimeout(context.state.timer);
        if (currentUrl.indexOf('idle') >= 0) {
          context.commit('setResetHomeYn', false);
          context.state.resetYn = true;
        }
        if (currentUrl.indexOf('admin') < 0 && context.state.resetYn && !context.state.adminModeYn) {
          context.state.timer = setTimeout(() => {
            context.commit('setResetHomeYn', true);
          }, context.state.returnToIdleDelay * 1000);
        }
      }
    },
    setResetHomeYn(context, resetHomeYn) {
      context.commit('setResetHomeYn', resetHomeYn);
    },
    clearIdle(context) {
      context.state.resetYn = false;
      clearTimeout(context.state.timer);
    },
    startIdle(context) {
      context.state.resetYn = true;
      clearTimeout(context.state.timer);
    },
    setProduct(context) {
      let masterdata = [];
      if (context.state.settingType == 1) {
        masterdata = masterdata_cafe;
      } else if (context.state.settingType == 2) {
        masterdata = masterdata_food;
      } else if (context.state.settingType == 3) {
        masterdata = masterdata_food;
      }
      context.commit('setProduct', masterdata.data);
    },
    setPosConfig(context, posconfig) {
      return new Promise((resolve) => {
        context.commit('setPosConfig', posconfig);
        resolve(1);
      });
    },
    setTbMstOpt(context) {
      return new Promise((resolve) => {
        let tbmstopt = [];
        if (context.state.settingType == 1) {
          tbmstopt = tbmstopt_cafe;
        } else if (context.state.settingType == 2) {
          tbmstopt = tbmstopt_food;
        } else if (context.state.settingType == 3) {
          tbmstopt = tbmstopt_food;
        }
        context.commit('setTbMstOpt', tbmstopt);
        resolve(1);
      });
    },
    setTbMstItem(context) {
      return new Promise((resolve) => {
        let tbmstitem = [];
        if (context.state.settingType == 1) {
          tbmstitem = tbmstitem_cafe;
        } else if (context.state.settingType == 2) {
          tbmstitem = tbmstitem_food;
        } else if (context.state.settingType == 3) {
          tbmstitem = tbmstitem_food;
        }
        context.commit('setTbMstItem', tbmstitem);
        resolve(1);
      });
    },
    setKioskItem(context) {
      return new Promise((resolve) => {
        let kioskitem = [];
        if (context.state.settingType == 1) {
          kioskitem = kioskitem_cafe;
        } else if (context.state.settingType == 2) {
          kioskitem = kioskitem_food;
        } else if (context.state.settingType == 3) {
          kioskitem = kioskitem_sco;
        }
        context.commit('setKioskItem', kioskitem.data);
        resolve(1);
      });
    },
    setRecommendItem(context) {
      return new Promise((resolve) => {
        let recommenditem = [];
        if (context.state.settingType == 1) {
          recommenditem = recommenditem_cafe;
        } else if (context.state.settingType == 2) {
          recommenditem = recommenditem_food;
        } else if (context.state.settingType == 3) {
          recommenditem = recommenditem_food;
        }
        context.commit('setRecommendItem', recommenditem.data);
        resolve(1);
      });
    },
    setMasterData(context) {
      return new Promise((resolve) => {
        let masterdata = [];
        if (context.state.settingType == 1) {
          masterdata = masterdata_cafe;
        } else if (context.state.settingType == 2) {
          masterdata = masterdata_food;
        } else if (context.state.settingType == 3) {
          masterdata = masterdata_food;
        }
        context.commit('setMasterData', masterdata.data);
        resolve(1);
      });
    },
    setAllergys(context) {
      return new Promise((resolve) => {
        let allergys = [];
        if (context.state.settingType == 1) {
          allergys = allergys_cafe;
        } else if (context.state.settingType == 2) {
          allergys = allergys_food;
        } else if (context.state.settingType == 3) {
          allergys = allergys_food;
        }
        context.commit('setAllergys', allergys.data);
        resolve(1);
      });
    },
    setIsSimpleToken(context, isSimpleToken) {
      context.commit('setIsSimpleToken', isSimpleToken);
    },
    async setCurrencyUnit(context, currencyUnit) {
      let currUnitText = currencyUnit == '001' ? '원' : currencyUnit == '002' ? '$' : '円';
      context.commit('setCurrUnitText', currUnitText);
      context.commit('setCurrencyUnit', currencyUnit);
    },
    setCurrencyUnitText(context, currUnitText) {
      context.commit('setCurrUnitText', currUnitText);
    },
    setOpenYn(context, openYn) {
      context.commit('setOpenYn', openYn);
    },
    setManualYn(context, manualYn) {
      context.commit('setManualYn', manualYn);
    },
    setManualOpenDate(context, manualOpenDate) {
      context.commit('setManualOpenDate', manualOpenDate);
    },
    setLoginCashierId(context, loginCashierId) {
      context.commit('setLoginCashierId', loginCashierId);
    },
    setPosmasterRenewalYn(context, posmasterRenewalYn) {
      context.commit('setPosmasterRenewalYn', posmasterRenewalYn);
    },
    setShopId(context, shopId) {
      context.commit('setShopId', shopId);
    },
    setPosNo(context, posNo) {
      context.commit('setPosNo', posNo);
    },
    setCpCd(context, cpCd) {
      context.commit('setCpCd', cpCd);
    },
    setStoreCd(context, storeCd) {
      context.commit('setStoreCd', storeCd);
    },
    setFirstPosTranYn(context, firstPosTranYn) {
      context.commit('setFirstPosTranYn', firstPosTranYn);
    },
    setReceiptDiscount(context) {
      return new Promise((resolve) => {
        let receiptdiscount = [];
        if (context.state.settingType == 1) {
          receiptdiscount = receiptdiscount_cafe;
        } else if (context.state.settingType == 2) {
          receiptdiscount = receiptdiscount_food;
        } else if (context.state.settingType == 3) {
          receiptdiscount = receiptdiscount_food;
        }
        context.commit('setReceiptDiscount', receiptdiscount.data);
        resolve(1);
      });
    },
    setMembershipApplyYn(context, membershipApplyYn) {
      context.commit('setMembershipApplyYn', membershipApplyYn);
    },
    setDefaultLanguage(context, defaultLanguage) {
      context.commit('setDefaultLanguage', defaultLanguage);
    },
    setLocale(context, locale) {
      context.commit('setLocale', locale);
    },
  },
  modules: {},
});

export default store;
